// material
import { styled } from "@mui/material/styles";
import { Container, Box, Typography, Grid, Card, CardContent } from "@mui/material";
import MContainer from "components/MContainer";
import CirclesIcon from "components/CirclesIcon";

// ----------------------------------------------------------------------
const ContactCard = styled(Card)(({ theme }) => ({
  height: '100%',
  textAlign: 'center',
  transition: 'transform 0.3s, box-shadow 0.3s',
  borderRadius: '16px',
  overflow: 'hidden',
  boxShadow: '0 6px 20px rgba(0, 0, 0, 0.08)',
  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: theme.shadows[10],
  },
}));

const ContactIconBox = styled(Box)(({ theme }) => ({
  margin: '0 auto 16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '80px',
  height: '80px',
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  position: 'relative',
  display: 'inline-block',
  zIndex: 4,
  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: '-10px',
    left: '0',
    width: '60px',
    height: '4px',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '2px',
  }
}));

export default function ContactUs() {
  return (
    <MContainer id="contact" className="paddedSection" sx={{ position: "relative", pt: 8, pb: 10 }}>
      <Box sx={{ position: 'relative', mb: 8, textAlign: { xs: 'center', md: 'left' } }}>
        <SectionTitle variant="h2" color="primary">
          Contact Us
        </SectionTitle>
      </Box>
      
      <Grid container spacing={4}>
        <Grid item xs={12} sm={4}>
          <ContactCard>
            <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
              <ContactIconBox>
                <Box component="img" src="/images/Phone.png" sx={{ width: '60px' }} />
              </ContactIconBox>
              <Typography variant="h6" gutterBottom color="text.primary">
                Call us today!
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                Our team is happy to help and is available Monday through Friday, 9 AM to 5 PM.
              </Typography>
              <Typography variant="body1">
                <Box 
                  component="a" 
                  href="tel:+15412036826" 
                  color="primary.main" 
                  sx={{ 
                    textDecoration: 'none',
                    fontWeight: 600,
                    fontSize: '18px',
                    display: 'inline-block'
                  }}
                >
                  541-203-6826
                </Box>
              </Typography>
            </CardContent>
          </ContactCard>
        </Grid>
        
        <Grid item xs={12} sm={4}>
          <ContactCard>
            <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
              <ContactIconBox>
                <Box component="img" src="/images/Email.png" sx={{ width: '60px' }} />
              </ContactIconBox>
              <Typography variant="h6" gutterBottom color="text.primary">
                Need assistance?
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                Looking for an out-of-stock item or need to quote some prices? Send us an e-mail and we will do the work for you!
              </Typography>
              <Typography variant="body1">
                <Box 
                  component="a" 
                  href="mailto:contact@minerssupplyco.com" 
                  color="primary.main" 
                  sx={{ 
                    textDecoration: 'none',
                    fontWeight: 600,
                    fontSize: '17px',
                    display: 'inline-block'
                  }}
                >
                  contact@minerssupplyco.com
                </Box>
              </Typography>
            </CardContent>
          </ContactCard>
        </Grid>
        
        <Grid item xs={12} sm={4}>
          <ContactCard>
            <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
              <ContactIconBox>
                <Box component="img" src="/images/Address.png" sx={{ width: '60px' }} />
              </ContactIconBox>
              <Typography variant="h6" gutterBottom color="text.primary">
                Our Main Office
              </Typography>
              <Typography variant="body2" color="text.secondary">
                is located at
              </Typography>
              <Typography variant="body1" sx={{ 
                mt: 1,
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: 1.6
              }}>
                8 The GRN, STE A<br />
                Dover, DE 19901-3618
              </Typography>
            </CardContent>
          </ContactCard>
        </Grid>
      </Grid>
    </MContainer>
  );
}
